import React from 'react'
  import { MDXTag } from '@mdx-js/tag'


  const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="h1" components={components}>{`Box`}</MDXTag>
      <MDXTag name="p" components={components}>{`Responsive box-model layout component.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-.jsx"
        }}>{`<Box
  p={5}
  fontSize={4}
  width={[ 1, 1, 1/2 ]}
  color='white'
  bg='magenta'>
  Box
</Box>
`}</MDXTag></MDXTag>
      <MDXTag name="h2" components={components}>{`Props`}</MDXTag>
      <MDXTag name="ul" components={components}>
        <MDXTag name="li" components={components} parentName="ul">{`All `}<MDXTag name="a" components={components} parentName="li" props={{
            "href": "/props/#margin-and-padding"
          }}>{`margin and padding props`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`width`}</MDXTag>{`: responsive `}<MDXTag name="a" components={components} parentName="li" props={{
            "href": "/props/#width"
          }}>{`width`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`fontSize`}</MDXTag>{`: responsive `}<MDXTag name="a" components={components} parentName="li" props={{
            "href": "props/#font-size"
          }}>{`font size`}</MDXTag></MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`color`}</MDXTag>{`: text color`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`bg`}</MDXTag>{`: background color`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`flex`}</MDXTag>{`: CSS flex shorthand property`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`order`}</MDXTag>{`: CSS order property`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`alignSelf`}</MDXTag>{`: CSS align-self property`}</MDXTag>
      </MDXTag>
           </MDXTag>;
  }

}
MDXContent.isMDXComponent = true;
export const _frontmatter = {};
      